import { render } from "./activeLabel.vue?vue&type=template&id=54de091b&scoped=true&ts=true"
import script from "./activeLabel.vue?vue&type=script&lang=ts"
export * from "./activeLabel.vue?vue&type=script&lang=ts"

import "./activeLabel.vue?vue&type=style&index=0&id=54de091b&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54de091b"]])

export default __exports__